import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  bold: {
    fontWeight: theme.typography.fontWeightHeavy
  },
  paddingBottom0: {
    paddingBottom: 0
  },
  nobullets: {
    listStyleType: "none",
    marginLeft: theme.spacing(0.5)
  },
  italic: {
    fontStyle: "italic"
  }
}));
